<template>
  <div style="overflow: hidden">
    <div class="grid-content bg-purple">
      <h2 style="float: left;">考核评分审核</h2>


      <div class="clear"></div> </div>
  <el-row :gutter="24">
    <el-col :span="24">
      <div class="grid-ent bg-purple">
        <div class="avatar"><el-avatar :size="104" :src="userlogo"></el-avatar></div>
        <div class="approval">
          <div class="total"><h2>当前总评分：</h2>
            <span v-if="seoregradeatotal==0">未评分</span>
            <span v-else>{{seoregradeatotal}}</span>
            <h2>当前评分评级：</h2>

            <span>

                                        <el-select v-model="seoregradea" placeholder="请选择" style="float: left;">
                                            <el-option
                                              v-for="item in gradelist"
                                              :key="item"
                                              :label="item"
                                              :value="item">
                                            </el-option>
                                          </el-select>
                                     </span>

          </div>
          <!-- <div class="point"><h2>当前审批点：</h2><span>太原市交通局<em>未处理</em></span></div> -->
        </div>
        <div class="button">
          <el-button type="success" v-if="typeid!=0" @click="setapproveLog()">审核评分</el-button>
          <!-- <el-button type="success" @click="process()">查看流程</el-button> -->

          <el-dialog  :visible.sync="dialogscoreprocess" >
            <el-timeline>
              <el-timeline-item v-for="(item,index) in approveLoglist" :key='index' :timestamp="item.createTime | myFuncton" >
                <el-card>
                  <h4>{{item.node | setnode}}</h4>
                  <p>状态：{{item.approveStatus | status}} </p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-dialog>
        </div>

      </div>
      <div class="grid-main bg-purple">
        <div class="table-box">
          <h2>请按照评分细则与考核资料审核分数并在评分细则下面修改评分</h2>

          <el-table
            :data="itemlist"
            border
            style="width: 100%;">
            <el-table-column
              width="60"
              type="index"
              label="序号"
            >
            </el-table-column>
            <el-table-column
              width="100"
              prop="scoreTypeName"
              label="指标类别"
            >
            </el-table-column>
            <el-table-column
              width="100"
              label="指标项与分值">
              <template slot-scope="scope">
                {{scope.row.scoreItem}}(分值：{{scope.row.scoreValue}}分)
              </template>
            </el-table-column>
            <el-table-column
              width="180"
              label="考核资料">

              <template slot-scope="scope">

                <div v-for="{items , index} in scope.row.fileJson" :key="index">
                  <el-link  type="primary" :href="items.url" target="_blank">{{items.fileName}}</el-link>
                  <br/>
                </div>

              </template>
            </el-table-column>

            <el-table-column

              label="分值及计算方式">
              <template slot-scope="scope" >
                <el-input v-model="scope.row.description" type="textarea" resize="none" :rows="5" disabled  placeholder="请输入分值及计算方式："></el-input>

              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="100"
              label="打分">
              <template slot-scope="scope" >
                <el-input  v-model="scope.row.itemScore" type="number"  placeholder="打分" oninput="if(value.length > 4) value=value.slice(0, 4)" @change = "onChange()"  @mousewheel.native.prevent  />
              </template>

            </el-table-column>
          </el-table>

        </div>
        <div class="bottom" id="firstAnchor">
          <el-button type="primary" @click="onUpdateChange()" >修改评分</el-button>
        </div>

      </div>
    </el-col>

<!--    <el-col :span="6">-->
<!--      <div class="grid-cont bg-purple" @click="dialogTableVisible = true">-->
<!--        <div class="aimg"><img src="../../assets/images/01.png"></div>-->
<!--        <div class="atitle">-->
<!--          <h3>新建工单</h3>-->
<!--          <span>线下考核</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="grid-cont bg-purple" @click="selectWorkOrder()">-->
<!--        <div class="aimg"><img src="../../assets/images/02.png"></div>-->
<!--        <div class="atitle">-->
<!--          <h3>我的工单</h3>-->
<!--          <span>线下考核</span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="grid-cont bg-purple" @click="questi()">-->
<!--        <div class="aimg"><img src="../../assets/images/04.png"></div>-->
<!--        <div class="atitle">-->
<!--          <h3>我的问卷</h3>-->
<!--          <span>线下考核</span>-->
<!--        </div>-->
<!--      </div>-->

<!--    </el-col>-->
  </el-row>

    <el-dialog class="table-box" style="background: none;  " :modal="true" :visible.sync="dialogTableVisible">
      <el-form ref="form" label-width="150px">
        <el-form-item label="考核内容：">
          <el-input v-model="workOrder.checkContent" type="text" placeholder="请输入考核内容"></el-input>
        </el-form-item>
        <el-form-item label="考核人数：">
          <el-input v-model="workOrder.checkPopulation" type="number" placeholder="请输入考核人数"></el-input>
        </el-form-item>
        <el-form-item label="考核地址：">
          <el-input v-model="workOrder.address" type="text" placeholder="请输入考核地址"></el-input>
        </el-form-item>
        <el-form-item label="考核点位数：">
          <el-input v-model="workOrder.pointNum" type="number" placeholder="请输入考核考核点位数"></el-input>
        </el-form-item>
        <el-form-item label="考核监督员：">
          <el-input v-model="workOrder.supervisor" type="text" placeholder="请输入考核监督员"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="workOrderAdd">确认提交</el-button>

        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog class="table-box" style="background: none; padding: 49px 20px;" :visible.sync="dialogworkVisible">
      <el-table
        :data="workOrlist"
        border
        style="width: 100%;
          height:280px">
        <el-table-column

          prop="checkContent"
          label="考核内容"
        >
        </el-table-column>
        <el-table-column

          prop="checkPopulation"
          label="考核人数"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="考核地址">

        </el-table-column>
        <el-table-column
          prop="pointNum"
          label="考核点位数">


        </el-table-column>

        <el-table-column
          prop="supervisor"
          label="考核监督员">

        </el-table-column>

      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="workOrderpageSize"
        @current-change="setselWorkOrder"
        :total="workOrdertotal">

      </el-pagination>

    </el-dialog>
  </div>
</template>

<script>
import { api_duck } from '../../assets/js/commt';
export default {
  name: "Showscore",
  props:['cid','typeid','curId'],
  data(){
    return {

      workOrder:{},
      WorkOrderpage:1,
      workOrdertotal:0,
      workOrderpageSize:10,
      workOrlist:[],
      dialogworkVisible:false,

      userlogo:'',

      seoregradeatotal:0,
      seoregradea:'',
      itemlist:[],

      gradeId:'',
      gradelist:['A', 'B', 'C', 'D'],


      dialogscoreprocess : false,

      approveLoglist:[],

      dialogTableVisible:false,

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selectGradeById();
    this.selectGradeByOperatorNums();
  },
  methods: {

    //详情页总分
    selectGradeByOperatorNums(){

      var that = this;
      var OperatorNums ={
        operatorNum:this.curId ,
      }
      this.$axios
        .post('/api/grade/getNewGradeByOperatorNum',OperatorNums)
        .then(function (res) {

          if(res.data.code==200){

            that.userlogo =  res.data.data.logo;


          }else{
            that.$message.error(res.data.msg);
          }


        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setapproveLog(){

      let that = this;
      let approveLogdata ={
        gradeId:this.cid ,
      }

      if(that.typeid==1){
        var apiurl = 'approveLog/tgApprover';
      }else if(that.typeid==2){
        var apiurl = 'approveLog/zfddApprover';
      }else if(that.typeid==3){
        var apiurl = 'approveLog/jtjApprover';
      }
      this.$confirm('此操作是平台审核, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios.defaults.withCredentials=true;
        this.$axios
          .post('/api/'+apiurl,approveLogdata)
          .then(function (res) {

            if(res.data.code==200){
              that.$message({
                message: '审核成功',
                type: 'success'
              });
              window.setTimeout(() => {
                location.reload();
              }, 1000);
            }else{
              that.$message.error(res.data.msg)
            }
          }).catch(function (error) { // 请求失败处理
          console.log("服务器错误"+error);
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    process(){
      let that = this;
      let approveLog ={
        gradeId:this.cid ,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/approveLog/getApproverLog',approveLog)
        .then(function (res) {
          if(res.data.data.length>0){
            that.dialogscoreprocess = true;
            that.approveLoglist = res.data.data;
          }else{
            that.dialogscoreprocess =  false;
            that.$message.error('暂未审批');

            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },

    //查看打分详情
    selectGradeById(){
      let that = this;
      this.greadeDetail(this.cid);
      let gradeIds = {
        gradeId:this.cid
      }
      this.$axios
        .post('/api/grade/selectGradeById',gradeIds)
        .then(function (res) {

          that.seoregradeatotal=res.data.data.totalPoints;
          that.seoregradea=res.data.data.grade;

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },
    onChange(){
      let that = this;
      let totalPoint = 0;
      for(var i=0; i<that.itemlist.length; i++){
        if(that.itemlist[i].itemScore !=null){
          if(that.itemlist[i].itemScore >=0){
            totalPoint += Number(that.itemlist[i].itemScore);
          }else {
            that.itemlist[i].itemScore =0;
          }
        }

      }
      this.seoregradeatotal =totalPoint


    },
    greadeDetail(index){
      let that = this;
      this.gradeId = index;

      let greade ={
        gradeId:this.gradeId,
      }
      this.$axios
        .post('/api/greadeDetail/selectGradeDetailByGradeId',greade)
        .then(function (res) {
         // console.log(res.data.data);
          that.itemlist = res.data.data;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //修改评分
    onUpdateChange(){
      let that = this;


      let ceratdata = {
        grade:this.seoregradea,
        gradeId:Number(this.gradeId),
        detailDtoList:[
        ]
      }
      for(let i=0; i<that.itemlist.length; i++){

        if(that.itemlist[i].itemScore <0){
          that.$message.error('打分项不能为负数');
          return false;
        }
        if(that.itemlist[i].itemScore == null){
          that.$message.error('请添加打分项');
          return false;
        }
        if(that.itemlist[i].itemScore >  that.itemlist[i].scoreValue){
          that.$message.error('打分项不能超过当前分值');
          return false;
        }
        ceratdata.detailDtoList.push({
          gradeDetailId:that.itemlist[i].gradeDetailId,
          itemScore:Number(that.itemlist[i].itemScore),
        })
      }

      this.$axios
        .post('/api/grade/updateGrade',ceratdata)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '修改成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg)
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
    //新建工单
    workOrderAdd(){
      let that = this;

      if (this.workOrder.checkContent == undefined ) {
        that.$message.error("请输入考核内容");
        return false;
      }
      if (this.workOrder.checkPopulation == undefined) {

        that.$message.error("请输入考核人数");
        return false;
      }
      if (this.workOrder.address == undefined) {
        that.$message.error("请输入考核地址");
        return false;
      }

      if (this.workOrder.pointNum == undefined) {
        that.$message.error("请输入考核考核点位数");
        return false;
      }

      if (this.workOrder.supervisor == undefined) {
        that.$message.error("请输入考核监督员");
        return false;
      }
      let workOrderdata ={
        checkContent:this.workOrder.checkContent,
        checkPopulation:this.workOrder.checkPopulation,
        address:this.workOrder.address,
        pointNum:this.workOrder.pointNum,
        supervisor:this.workOrder.supervisor,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/workOrder/workOrderAdd',workOrderdata)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '提交成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg)
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //我的工单
    selectWorkOrder(){
      let that = this;
      this.dialogworkVisible = true;
      let workOrderd ={
        page:this.WorkOrderpage,
        pageSize:this.workOrderpageSize,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/workOrder/selectWorkOrder',workOrderd)
        .then(function (res) {
          that.workOrdertotal = res.data.data.total;
          that.workOrlist = res.data.data.list;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setselWorkOrder(WorkOrderpage){
      this.WorkOrderpage = WorkOrderpage;
      this.selectWorkOrder();
    },

    //问卷
    questi(){
      location.href=api_duck+'login?phong='+this.userphone+'&type=danche';
    },

  },
  watch: {

  },
  filters:{ //钩子
    myFuncton(date_time){
      if (date_time !=null){

        var date=new Date(+new Date(date_time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
        return date
      }else {
        return date_time
      }

    },
    setnode(date){

      if (date ==1){
        return '天鸽智库评分';
      }else if (date ==2) {
        return '天鸽智库审核';
      } else if (date ==3) {
        return '执法大队审核';
      }
      else if (date ==4) {
        return '交通局审核';
      }

    },
    status(date){

      if (date ==1){
        return '未审批';
      }else if (date ==2) {

        return '已审批';
      }
    },
  }
}
</script>
<style>
.table-box h2{
  font-size: 0.4rem;
}
/deep/ .el-button--primary{
  margin-bottom: 0px!important;
  margin-top: 0px!important;
  height: auto;
}
.el-timeline-item__timestamp{
  text-align: left;
}
.el-card__body h4{
  margin:10px 0;
  text-align: left;
}
.el-card__body p{
  margin: 0;
  text-align: left;
}
</style>
<style scoped>

.grid-content h2{
  margin-bottom: 0px!important;
  margin-top: 0px!important;
}
/deep/ .el-button--primary{
  margin-bottom: 0px!important;
  margin-top: 0px!important;
}
.grid-cont .aimg {
  width: 54px;
  height: 56px;
  margin: 39px 0 39px 62px;
}
.grid-cont .aimg img {
  width: 100%;
  height: 100%;
}
.grid-cont .atitle {
  margin: 36px 60px;
}
.grid-cont .atitle h3 {
  margin: 0;
  line-height: 30px;
}
.grid-cont .atitle span {
  margin: 0;
  line-height: 30px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.grid-cont {
  border-radius: 0px;
  min-height: 36px;
  min-width: 327px!important;
  position: relative;
  margin-bottom: 20px;
  padding: 0px!important;
  display: flex;
}
.clear
{
  clear:both;
}
.grid-ent {
  border-radius: 0px;
  min-height: 36px;
  min-width: 327px!important;
  position: relative;
  margin-bottom: 20px;
  padding: 0px!important;
  display: flex;
}
.grid-ent .avatar {
  text-align: left;
}
.grid-ent .avatar {
  width: 104px;
  height: 104px;
  margin: 33px 75px;
}
.el-select {
  width: 120px;
}
.grid-ent .approval {
  margin: 27px 0;
}
.grid-ent .approval .total {
  display: flex;
  line-height: 55px;
}
.grid-ent .approval h2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
  margin: 0;
}
.grid-ent .approval span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  margin-right: 59px;
}
.grid-ent .approval h2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
  margin: 0;
}
.el-tag{
  margin: 3px 0 0px 30px;
}

.grid-ent .button {
  margin-top: 0.5rem;
  position: absolute;
  right: 40px;
}
.grid-ent .button .el-button--success {
  color: #109585;
  background: none;
  border-color: #109585;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: normal;
}
.grid-ent .button button span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: normal;
}

.grid-content h2{
  margin-bottom: 0px!important;
  margin-top: 0px!important;
}
/deep/ .el-button--primary{
  margin-bottom: 0px!important;
  margin-top: 0px!important;
}
.grid-cont .aimg {
  width: 54px;
  height: 56px;
  margin: 17px 0 39px 62px;
}
.grid-cont .aimg img {
  width: 100%;
  height: 100%;
}
.grid-cont .atitle {

  margin: 47px 60px;
  line-height: 0rem;
}
.grid-cont .atitle h3 {
  margin: 0;
  line-height: 30px;

}
.grid-cont .atitle span {
  margin: 0;
  line-height: 30px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.grid-cont {
  border-radius: 0px;
  min-height: 36px;
  min-width: 327px!important;
  position: relative;
  margin-bottom: 20px;
  padding: 0px!important;
  display: flex;
}
.clear
{
  clear:both;
}
.grid-ent {
  border-radius: 0px;
  min-height: 36px;
  min-width: 327px!important;
  position: relative;
  margin-bottom: 20px;
  padding: 0px!important;
  display: flex;
}
.grid-ent .avatar {
  text-align: left;
}
.grid-ent .avatar {
  width: 104px;
  height: 104px;
  margin: 33px 75px;
}
.el-select {
  width: 120px;
}
.grid-ent .approval {
  margin: 27px 0;
}
.grid-ent .approval .total {
  display: flex;
  line-height: 55px;
}
.grid-ent .approval h2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
  margin: 0;
}
.grid-ent .approval span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  margin-right: 59px;
}
.grid-ent .approval h2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
  margin: 0;
}
.el-tag{
  margin: 3px 0 0px 30px;
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ input[type='number'] {
  -moz-appearance: textfield;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  background-color: #FFFFFF;
  border: 0px;
  color: #606266;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Showscore.vue